import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import banner1 from "../assets_user/img/fullbanner1.webp";
import banner2 from "../assets_user/img/fullbanner2.webp";
import banner3 from "../assets_user/img/fullbanner3.webp";
import banner4 from "../assets_user/img/fullbanner4.webp";

import grid1 from "../assets_user/img/grid1.webp";
import grid2 from "../assets_user/img/grid2.webp";
import grid3 from "../assets_user/img/grid3.webp";
import grid4 from "../assets_user/img/grid4.webp";
import gridslide1 from "../assets_user/img/gridslide1.webp";
import gridslide2 from "../assets_user/img/gridslide2.webp";
import gridslide3 from "../assets_user/img/gridslide3.webp";
import gridslide4 from "../assets_user/img/gridslide4.webp";
import gridslide5 from "../assets_user/img/gridslide5.webp";
import CreateSlug from "../components/extra/CreateSlug";
import { useBlogContext } from "../../fetchdata/BlogContext";

const Home = () => {

  const navigate = useNavigate();

  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    layout,
  } = useBlogContext();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };

  const [ratings, setRatings] = useState([]);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);
  const [AllCategory, setAllCategory] = useState([]);

  const [defaultState, setdefaultState] = useState('delhi');


  const [loading, setloading] = useState(true);

  const [Data, setData] = useState([]);
 

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
            console.log("getRating", data);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

 
   const getBlog = async () => {
   
         
          setloading(true);
          try {
          const { data } = await axiosInstance.get(`/get-catgeory-product?location=${ defaultState }&type=0`);
         setData(data.categoriesWithProducts || []);
            // Delay the execution of buildScript by 1 secon
            console.log('datadata',data);
            const allProducts = data.categoriesWithProducts.flatMap(cat => cat.products || []);
            setProducts(allProducts ?? [])
          }
          catch (error) {
            console.log(error);
            // toast.error("Error fetching Single Blog!");
          } finally {
            setloading(false);
          }
      
      
   };
  


  useEffect(() => {
        const location = localStorage.getItem('location');
     let stateSlug  = 'delhi';
    if( location !== "[object Object]" && location){
        stateSlug = CreateSlug(location);
     } 
     setdefaultState(stateSlug);
    getBlog();
    getRating();
  }, []);

  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      console.log("products", data);
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      <Header />

      {/* <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && (
          <>
            <title>{Headers.meta_title}</title>
            {Headers.meta_description && (
              <meta name="description" content={Headers.meta_description} />
            )}
          </>
        )}
      </Helmet> */}

      <main className="page ">
     

     <section className="hero-wrap py-5 py-lg-6  " style={{backgroundImage:`url(${layout.slider_img})`,backgroundSize:'cover',backgroundBlendMode:'multiply',backgroundColor:'#0000003b'}}>
            <div className="skeleton w-100 position-absolute top-0 left-0 h-100"  style={{zIndex:-1}} />


{/* decorative side images (replace srcs or remove) */}
  {/* <img class="veg-left"  src="left.png"  alt=""> */}
  {/* <img class="veg-right" src="right.png" alt=""> */}
  <div className="container position-relative">
    {/* Heading */}
    <div className="row justify-content-center text-center">
      <div className="col-12 col-lg-10 col-xxl-8">
        <h1 className="hero-title display-5 display-lg-4  text-white fw-light my-4">
          {layout.top_bar}    
        </h1>
      </div>
    </div>
    <div className="d-none">

    
    {/* Search row */}
    <div className="row justify-content-center g-3 ">
      <div className="col-12 col-lg-4">
        <div className="input-group pill-input px-2">
          <span className="input-group-text bg-transparent border-0">
            {/* location icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={18}
              fill="#ff5a00"
              viewBox="0 0 16 16"
            >
              <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zM8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
            </svg>
          </span>
          <input
            className="form-control"
            type="text"
            placeholder="Enter your location"
          />
          <span className="input-group-text bg-transparent border-0">
            {/* chevron */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={18}
              fill="#999"
              viewBox="0 0 16 16"
            >
              <path d="M1.5 5.5l6 6 6-6" />
            </svg>
          </span>
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <div className="input-group pill-input px-2">
          <input
            className="form-control ps-3"
            type="text"
            placeholder="Search anything "
          />
          <span className="input-group-text bg-transparent border-0">
            {/* search icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={18}
              fill="#999"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.868-3.833zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </span>
        </div>
      </div>
    </div>
    {/* Tiles */}
    </div>
 
 
<div className="row g-4 g-lg-5 mt-4 mt-lg-5">
  {isLayoutLoading
    ? Array.from({ length: 3 }).map((_, index) => (
        <div className="col-12 col-md-6 col-lg-4" key={index}>
          <div className="skeleton w-100" style={{ aspectRatio: '4/5', height: 'auto' }}></div>
        </div>
      ))
    : layout.latest_product_banner?.map((item, index) => (
        <div className="col-12 col-md-6 col-lg-4" key={index}>
          <div className="card-tile d-flex flex-column position-relative border  ">

            
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <div className="h3 fw-bold mb-1 text-white">{item.imageTITInput}</div>
                <div className="tile-sub mb-3 text-white">{item.imageParaInput}</div>
               </div>
              <img
                className="tile-img d-md-block"
                src={item.imageInput}
                alt={item.imageTITInput || "Banner Image"}
              />
            </div>
            <div className="mt-4">
              <Link to={item.imageUrlInput} className="tile-cta bg-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={26}
                  height={26}
                  viewBox="0 0 24 24"
                  fill="black"
                >
                  <path d="M13.172 12 8.222 7.05l1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      ))}
</div>


  </div>
</section>


 {Data.map((category, index) => (
  <div key={index}>
    <section class="py-4">
  <div class="container">
    {/* Section Header */}
    <div className="d-flex align-items-center justify-content-between mt-5 mb-3">
      <h5 className="section-title mb-0">{category.title}</h5>
      <Link to={`/shop/${defaultState}/${category.slug}`} className="see-all">
        See all
      </Link>
    </div>

    {/* Product Grid */}
    <div className="row g-4">
      {category.products.map((product, index) => {
        const cartItem = cartItems.find(item => item.id === product._id);
        const quantity = cartItem ? cartItem.quantity || 1 : 0;

        return (
          <div className="col-12 col-md-6 col-lg-3" key={index}>
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
              <div className="position-relative">
                <Link to={`/product/${product.slug}`}>
                  <img
                    src={product.pImage ?? 'https://via.placeholder.com/300x200?text=No+Image'}
                    className="w-100"
                    alt={product.title}
                    style={{ height: 170, objectFit: 'cover' }}
                  />
                </Link>

                {/* Dark overlay */}
                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(0,0,0,.4) 0%, rgba(0,0,0,0) 35%, rgba(0,0,0,.55) 100%)'
                  }}
                ></div>

                {/* Optional Ribbon */}
                {product.isSpecial && (
                  <span
                    className="position-absolute top-0 start-0 m-2 small fw-bold px-2 py-1 rounded-1 text-white"
                    style={{ background: '#ff7a00' }}
                  >
                    SPECIAL
                  </span>
                )}

                {/* Rating badge (dummy value or from product) */}
                <span className="position-absolute top-0 end-0 m-2 badge rounded-pill bg-success">
                  <i className="ri-star-fill me-1" />
                  {product.rating ?? '4.0'}
                </span>

                {/* Title on image */}
                <div className="position-absolute bottom-0 start-0 w-100 p-3">
                  <h6 className="text-white mb-0 fw-bold text-truncate">
                    {product.title ?? 'Untitled Product'}
                  </h6>
                </div>
              </div>

              <div className="card-body">
                {/* Optional Tags (static or dynamic) */}
                <div className="text-muted small">Indoor • Synthetic</div>

                {/* Static or dynamic location/distance */}
                <div className="d-flex justify-content-between small">
                  <span className="text-muted">Location TBD</span>
                  <span className="text-muted">-- km</span>
                </div>

                {/* Extra badge */}
                <div className="mt-2">
                  <span className="badge text-secondary-emphasis bg-body-secondary border rounded-pill">
                    <i className="ri-restaurant-2-line me-1" /> Table booking
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div> 
 </section>
    </div>
))}

  

        <div className="container mt-4  d-none">
          <Swiper
            breakpoints={{
              300: {
                slidesPerView: 3,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 15, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 6,
                spaceBetween: 15, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 6,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
            pagination={true}
            modules={[Pagination, Navigation]}
            className="swiper-wrapper"
          >
            {isLayoutLoading
              ? Array.from({ length: 6 }).map((_, index) => (
                <SwiperSlide>
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.4",
                    }}
                  ></div>
                </SwiperSlide>
              ))
              : layout.service_logos && (
                <>
                  {layout.service_logos.map((image, index) => (
                    <SwiperSlide
                      key={index}
                      to={image.imageUrlInput}
                      className="container my-4 py-2 d-block"
                    >
                      <Link to={image.imageUrlInput}>
                        <img
                          src={image.imageInput}
                          width="100%"
                          alt=""
                          className="w-100"
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </>
              )}
          </Swiper>
        </div>

  
      </main>

      <Footer />
    </>
  );
};

export default Home;
